/**
 * Sprint S13.1.B.1 — reusable single-select dropdown field.
 */
import type { UseFormRegisterReturn } from "react-hook-form";
import { cn } from "@/lib/utils";

export interface SelectOption {
  value: string;
  label: string;
}

interface Props {
  label: string;
  hint?: string;
  error?: string;
  options: SelectOption[];
  registration: UseFormRegisterReturn;
  placeholder?: string;
}

const BASE =
  "w-full rounded-lg border bg-cream-light px-4 py-3 text-[15px] text-navy-deep focus:outline-none focus:ring-2 focus:ring-amber/60 focus:border-amber/40 transition";

export function FieldSelect({
  label,
  hint,
  error,
  options,
  registration,
  placeholder,
}: Props) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-[13px] font-medium text-navy">
        {label}
      </span>
      <select
        {...registration}
        className={cn(BASE, error ? "border-coral" : "border-cream-border")}
      >
        {placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {hint && !error ? (
        <span className="mt-1 block text-[12px] text-taupe">{hint}</span>
      ) : null}
      {error ? (
        <span className="mt-1 block text-[12px] text-coral">{error}</span>
      ) : null}
    </label>
  );
}
